<template>
  <div class="mb-4 p-4 -mx-6 border-0 border-b border-solid border-grey-300 flex items-center justify-between">
    <div class="flex items-center">
      <div :style="{backgroundImage: `url(${$store.state.room.mainPhoto})`}" class="w-10 h-10 bg-cover bg-no-repeat rounded-xlg" />
      <div class="ml-2 leading-5">
        <div class="font-semibold">
          {{ $store.state.room.name }}
        </div>
        <div>{{ $store.state.venue.name }}</div>
      </div>
    </div>
    <div class="flex flex-col text-tiny">
      <div v-if="$store.state.minimumPricing.perHour">
        <template v-if="$store.state.minimumPricing.perHour.hasOther">
          from
        </template>
        <span class="font-semibold">{{ $store.state.minimumPricing.perHour.price.formatted }}</span> / hour
      </div>
      <div v-if="$store.state.minimumPricing.perDay">
        <template v-if="$store.state.minimumPricing.perDay.hasOther">
          from
        </template>
        <span class="font-semibold">{{ $store.state.minimumPricing.perDay.price.formatted }}</span> / day
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RtbRoomPricingBar',
};
</script>
